module.exports = __webpack_public_path__ + "static/media/telegram.ffc987f2.svg";